import { render } from "./SmallSiteView.vue?vue&type=template&id=bd62adf6&scoped=true"
import script from "./SmallSiteView.vue?vue&type=script&lang=js"
export * from "./SmallSiteView.vue?vue&type=script&lang=js"

import "./SmallSiteView.vue?vue&type=style&index=0&id=bd62adf6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd62adf6"]])

export default __exports__